/**
 * カテゴリー情報登録 バリデーションルール
 */
export const ja = {
  nameJa: 'required|max:128',
  nameUs: 'required|max:128',
  nameZhTw: 'required|max:128',
  nameZhCn: 'required|max:128',
  nameKr: 'required|max:128',
}

export const tw = {
  nameJa: 'required|max:128',
  nameUs: 'required|max:128',
  nameZhTw: 'required|max:128',
  nameZhCn: 'required|max:128',
  nameKr: 'max:128',
}

export const cn = {
  nameJa: 'required|max:128',
  nameUs: 'required|max:128',
  nameZhTw: 'required|max:128',
  nameZhCn: 'required|max:128',
  nameKr: 'max:128',
}

export const us = {
  nameJa: 'max:128',
  nameUs: 'required|max:128',
  nameZhTw: 'max:128',
  nameZhCn: 'max:128',
  nameKr: 'max:128',
}

const getRules = (language) => {
  switch (language) {
    case 'ja':
      return ja
    case 'us':
      return us
    case 'zh-tw':
      return tw
    case 'zh-cn':
      return cn
    default:
      return ja
  }
}

export default getRules(process.env.VUE_APP_LANG)
